'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-78/node_modules/@eliadmin/core/src/components/wholesale/wholesale-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-78/node_modules/@eliadmin/core/src/components/wholesale/wholesale-form.tsx").WholesaleForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/wholesaleForm").then(m => ({ default: m.WholesaleForm })));
export function WholesaleForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

